import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { initI18n } from '../i18n/i18n';
import { renderPartialWithI18n } from '../Utils/renderPartialWithI18n';

import AutosuggestRender from './AutosuggestRender';
import AutosuggestRenderPLaceholderCustom from './AutosuggestRenderPlaceholderDefault';
import Header from './Header';
import Menu from './Menu';
import Footer from './Footer';
import RegisterFormHomeDesktop from './RegisterFormHomeDesktop';
import RegisterFormHomeMobile from './RegisterFormHomeMobile';
import ModifyPassword from './ModifyPassword';
import DataLayer from './DataLayer';
import FacebookConnect from './Facebook';
import NotFound from './PageNotFound';
import ScrollUp from './ScrollUp';
import RegistrationCurrentSale from './RegistrationCurrentSale';
import LoginDesktop from './Login/Desktop';
import LoginMobile from './Login/Mobile';
import LoginMobileConnect from './Login/Mobile/LoginMobileConnect';
import LoginMobileRegister from './Login/Mobile/RegisterMobile';
import Toaster from './Toaster';
import LoginBarExternal from './Login/Desktop/LoginBarExternal';
import Preference from 'External/PreferenceCenter';
import BannerRgpd from 'External/BannerRGPD';
import MenuSelfCareExternal from './MenuSelfCare';
import MagazineIndex from './magazine/index';
import MagazineArticle from './magazine/article';

// === Ta fonction render conservée
const render = (className: string, reactNode: any) => {
  if (document.querySelectorAll(className).length)
    [].slice
      .call(document.querySelectorAll(className))
      .map((htmlNode: any) => ReactDOM.render(reactNode, htmlNode));
};

export const renderPartials = () => {
  document.addEventListener('DOMContentLoaded', async () => {
    console.log('Loading external injection');

    // ⚡ Composants qui n’ont PAS besoin de traductions
    render('#react-autosuggest', <AutosuggestRender />);
    render(
      '#react-autosuggest-placeholder-default',
      <AutosuggestRenderPLaceholderCustom />
    );
    // render('#react-preference-center', <Preference />);
    // render('#react-menu', <Menu />);
    //render('#react-footer', <Footer />);
    // render('.react-register-home-desktop', <RegisterFormHomeDesktop />);
    // render('.react-register-home-mobile', <RegisterFormHomeMobile />);
    render('#react-modify-password', <ModifyPassword />);
    render('#react-dataLayer', <DataLayer />);
    // render('#react-facebook-connect', <FacebookConnect />);
    render('#react-page-no-found', <NotFound />);
    render('#react-scrollup', <ScrollUp />);
    // render('#react-registration-current-sales', <RegistrationCurrentSale />);
    // render('#react-login', <LoginDesktop />);
    // render('#react-login-bar', <LoginBarExternal />);
    // render('#react-login-mobile', <LoginMobile />);
    // render('#react-login-mobile-register', <LoginMobileRegister />);
    // render('#react-login-mobile-connect', <LoginMobileConnect />);
    render('.react-toaster', <Toaster />);
    // render('#react-banner-rgpd', <BannerRgpd />);
    render('#react-menu-selfcare', <MenuSelfCareExternal />);

    // ⚡ Composants qui ont BESOIN d’i18n
    await initI18n(); // attendre i18n
    console.log('i18n ready, rendering components that need translations');
    renderPartialWithI18n(<BannerRgpd />, '#react-banner-rgpd');
    renderPartialWithI18n(<Header />, '#react-header');
    renderPartialWithI18n(<Footer />, '#react-footer');
    renderPartialWithI18n(<Preference />, '#react-preference-center');
    renderPartialWithI18n(<NotFound />, '#react-page-no-found');
    renderPartialWithI18n(<MagazineArticle />, '#react-magazine-article');
    renderPartialWithI18n(<MagazineIndex />, '#react-magazine-index');
    // si d’autres composants utilisent useTranslation, les ajouter ici
  });
};
